const config = {
  production: true,
  apiEndpoint: "//mequidox.com/api/v1/",
};

export default config;
